import { supabase } from "@/integrations/supabase/client";

export interface RoomRateInfo {
  id: string;
  room_type: string | null;
  description: string | null;
  notes: string | null;
}

/**
 * Fetch supplier_room_rates for any items that carry a room_rate_id and
 * return a Map keyed by id. Safe to call with an empty/no-accommodation list.
 */
export async function fetchRoomRatesForItems(
  items: Array<{ room_rate_id?: string | null }>
): Promise<Map<string, RoomRateInfo>> {
  const ids = Array.from(
    new Set(
      (items || [])
        .map((i) => i?.room_rate_id)
        .filter((v): v is string => !!v)
    )
  );
  if (!ids.length) return new Map();
  const { data } = await supabase
    .from("supplier_room_rates")
    .select("id, room_type, description, notes")
    .in("id", ids);
  return new Map((data || []).map((r) => [r.id, r as RoomRateInfo]));
}

/**
 * Attach a `room_rate` field to an item when it has a matching room_rate_id.
 * Idempotent: returns the original item when no rate is found.
 */
export function attachRoomRate<T extends { room_rate_id?: string | null }>(
  item: T,
  map: Map<string, RoomRateInfo>
): T & { room_rate?: RoomRateInfo | null } {
  const id = item?.room_rate_id;
  if (id && map.has(id)) {
    return { ...item, room_rate: map.get(id) || null };
  }
  return item;
}